import React, {Component, PureComponent} from "react";
import EventsById from "../../components/EventById/EventsById";
import Xhr from "../../helpers/Xhr";
import Loading from "../../components/Loading";
import Breadcumbs from "../../components/Breadcumbs";
import {connect} from "react-redux";

class LiveById extends Component {
	state = {
		data       : {
			events  : [],
			factors : [],
			leagues : [],
			results : [],
			sports  : [],
		},
		fetching   : true
	};

	intervalId = 0;

	shouldComponentUpdate(nextProps, nextState) {
		const isStateChange = JSON.stringify(nextState.data) !== JSON.stringify(this.state.data);
		const isPropsChange = JSON.stringify(nextProps) !== JSON.stringify(this.props);

		return isStateChange || isPropsChange;
	}

	componentWillMount() {
		this.loadData(this.props);

		this.intervalId = setInterval(this.loadData.bind(this), 5000);
	}

	componentWillUnmount() {
		clearInterval(this.intervalId);
	}

	componentWillReceiveProps(nextProps) {
		this.loadData(nextProps);
	}

	loadData(props = null) {
		const {events, sports, user} = props || this.props;
		let isNeedMax = false;
		if ( user.info.hasOwnProperty('role') && (user.info.role === 'root' || user.info.role === 'bookmaker') ) {
			isNeedMax = true;
		}

		if ( events ) {
			Xhr.getLiveData(events, isNeedMax).then((resp) => this.setState({data : resp.data, fetching : false}));
		}

		if ( sports ) {
			Xhr.getLiveDataBySports(sports, isNeedMax).then((resp) => this.setState({data : resp.data, fetching : false}));
		}
	}

	getBreadcumbs() {
		let data = [];

		data.push({key : 'Главная', value : ''}, {key : 'Live', value : '/live'});

		if ( this.state.data.sports.length === 1 ) {
			const sport = this.state.data.sports[0];
			let insert = {};
			insert['key'] = sport.name;
			insert['value'] = `/live-sport/${sport.id}`;

			data.push(insert);
		}

		if ( this.state.data.leagues.length === 1 ) {
			const league = this.state.data.leagues[0];
			let insert = {};
			insert['key'] = league.name;
			insert['value'] = '';

			data.push(insert);
		}

		return data;
	}

	render() {
		return (
			<div className="body__container__side-right event">
				{/*BREADCUMBS*/}
				<Breadcumbs data={this.getBreadcumbs()}/>

				{this.state.fetching && <Loading/>}
				<EventsById type="live" data={this.state.data}/>
			</div>
		);
	}
}

export default connect(
	state => ({
		user : state.user
	}),
	dispatch => ({})
)(LiveById);


// WEBPACK FOOTER //
// ./src/app/pages/LiveById/LiveById.js